export const GET_ALL_PRODUCTS_START = 'GET_ALL_PRODUCTS_START';
export const GET_ALL_PRODUCTS_SUCCESS = 'GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_FAIL = 'GET_ALL_PRODUCTS_FAIL';

export const GET_CURRENT_PRODUCT_START = 'GET_CURRENT_PRODUCT_START';
export const GET_CURRENT_PRODUCT_SUCCESS = 'GET_CURRENT_PRODUCT_SUCCESS';
export const GET_CURRENT_PRODUCT_FAIL = 'GET_CURRENT_PRODUCT_FAIL';
export const REMOVE_CURRENT_PRODUCT = 'REMOVE_CURRENT_PRODUCT';

export const GET_SIMILAR_PRODUCTS_START = 'GET_SIMILAR_PRODUCTS_START';
export const GET_SIMILAR_PRODUCTS_SUCCESS = 'GET_SIMILAR_PRODUCTS_SUCCESS';
export const GET_SIMILAR_PRODUCTS_FAIL = 'GET_SIMILAR_PRODUCTS_FAIL';

export const GET_SEARCH_ALL_PRODUCTS_START = 'GET_SEARCH_ALL_PRODUCTS_START';
export const GET_SEARCH_ALL_PRODUCTS_SUCCESS = 'GET_SEARCH_ALL_PRODUCTS_SUCCESS';
export const GET_SEARCH_ALL_PRODUCTS_FAIL = 'GET_SEARCH_ALL_PRODUCTS_FAIL';

export const CREATE_PRODUCT_START = 'CREATE_PRODUCT_START';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_FAIL = 'CREATE_PRODUCT_FAIL';

export const GET_USER_PRODUCTS_START = 'GET_USER_PRODUCTS_START';
export const GET_USER_PRODUCTS_SUCCESS = 'GET_USER_PRODUCTS_SUCCESS';
export const GET_USER_PRODUCTS_FAIL = 'GET_USER_PRODUCTS_FAIL';

export const UPDATE_USER_PRODUCT_STATUS_START = 'UPDATE_USER_PRODUCT_STATUS_START';
export const UPDATE_USER_PRODUCT_STATUS_SUCCESS = 'UPDATE_USER_PRODUCT_STATUS_SUCCESS';
export const UPDATE_USER_PRODUCT_STATUS_FAIL = 'UPDATE_USER_PRODUCT_STATUS_FAIL';

export const DELETE_USER_PRODUCT_START = 'DELETE_USER_PRODUCT_START';
export const DELETE_USER_PRODUCT_SUCCESS = 'DELETE_USER_PRODUCT_SUCCESS';
export const DELETE_USER_PRODUCT_FAIL = 'DELETE_USER_PRODUCT_FAIL';

export const EDIT_USER_PRODUCT_START = 'EDIT_USER_PRODUCT_START';
export const EDIT_USER_PRODUCT_SUCCESS = 'EDIT_USER_PRODUCT_SUCCESS';
export const EDIT_USER_PRODUCT_FAIL = 'EDIT_USER_PRODUCT_FAIL';

export const GET_CURRENT_USER_PRODUCT_START = 'GET_CURRENT_USER_PRODUCT_START';
export const GET_CURRENT_USER_PRODUCT_SUCCESS = 'GET_CURRENT_USER_PRODUCT_SUCCESS';
export const GET_CURRENT_USER_PRODUCT_FAIL = 'GET_CURRENT_USER_PRODUCT_FAIL';
export const REMOVE_CURRENT_USER_PRODUCT = 'REMOVE_CURRENT_USER_PRODUCT';

export const SEND_PRODUCT_COMPLAINT_START = 'SEND_PRODUCT_COMPLAINT_START';
export const SEND_PRODUCT_COMPLAINT_SUCCESS = 'SEND_PRODUCT_COMPLAINT_SUCCESS';
export const SEND_PRODUCT_COMPLAINT_FAIL = 'SEND_PRODUCT_COMPLAINT_FAIL';
export const SEND_PRODUCT_COMPLAINT_DISCARD = 'SEND_PRODUCT_COMPLAINT_DISCARD';

export const CHANGE_PRODUCT_INFO = 'CHANGE_PRODUCT_INFO';

export const GET_CURRENT_PRODUCT_BID = 'GET_CURRENT_PRODUCT_BID';
